// product-variant-selector.js (patched)
// Wait for the theme.modules object to exist before running initialization.
// If theme.modules does not appear within timeout, abort initialization to avoid runtime errors.

function whenThemeReady(cb, timeoutMs = 5000) {
  if (window.theme && theme.modules) { cb(true); return; }
  var waited = 0;
  var int = setInterval(function () {
    if (window.theme && theme.modules) { clearInterval(int); cb(true); return; }
    waited += 100;
    if (waited >= timeoutMs) { clearInterval(int); cb(false); }
  }, 100);
}

whenThemeReady(async function (ready) {
  if (!ready) {
    // Theme not ready within timeout — skip initialization to avoid errors.
    console.warn('product-variant-selector: theme.modules not present; skipping module init');
    return;
  }

  try {
    const {
      updateURLParams,
      historyPush,
      parseHTML,
      getParentSection
    } = await import(window.theme.modules.utils);

    const isEqual = (arr1, arr2) => arr1.toString() === arr2.toString();
    const strEsc = (str) => (str || '').replace(/["\\]/g, '\\$&');
    const parseJSON = (el) => el && JSON.parse(el.textContent);
    const baseComponent = await import(window.theme.modules.baseComponent);

    customElements.define('product-variant-selector', class extends baseComponent.default {
      elements = {
        variantsJSON: '[data-variants-json]',
        optionsJSON: '[data-options-with-values]'
      };

      render() {
        this.cache = {};
        this.isProductPage = this.hasAttribute('product-page');

        // Cache DOM refs used below
        this.$variantsJSON = this.querySelector(this.elements.variantsJSON);
        this.$optionsJSON = this.querySelector(this.elements.optionsJSON);

        this.variantsData = parseJSON(this.$variantsJSON) || [];
        this.optionsData = parseJSON(this.$optionsJSON) || [];

        this._getDefaultVariant();
        this._checkUnavailable();
        this.addEventListener('change', this._variantChangeHandler.bind(this));
        this.on('qtyStatusUpdate', (e, data) => {
          this.cache[+data.variantId] = data.html.outerHTML;
        }, false);
        this._setInititalCache();
      };

      _getDefaultVariant() {
        this.variant = this.variantsData.find(v => v.id === +this.getAttribute('current-variant-id'));
      };

      _setInititalCache() {
        const parentSection = this.getParentSection();
        if (parentSection && this.variant) {
          this.cache[this.variant.id] = parentSection.outerHTML;
        }
      };

      _checkUnavailable() {
        // Guard if optionsData or variant missing
        if (!this.optionsData || !this.variant) return;
        this.optionsData.map((option, i) => {
          let optionsToCheck = [...this.variant.options];
          option.values.map(optionValue => {
            optionsToCheck[i] = optionValue;
            const match = this._findVariantByOptions(optionsToCheck);
            this._toggleOption(option.name, optionValue, !match);
          });
        });
      };

      _toggleOption(name, value, disable) {
        // fixed selector (closing bracket) and defensive guard if input not found
        const selector = `[name="${strEsc(name)}"][value="${strEsc(value)}"]`;
        const targetInput = this.querySelector(selector);

        if (!targetInput) {
          // Nothing to toggle — avoid throwing errors.
          return;
        }

        if (disable) {
          targetInput.setAttribute('data-unavailable', '');
        } else {
          targetInput.removeAttribute('data-unavailable');
        }
      };

      _variantChangeHandler(e) {
        if (!e.detail?.synthetic) {
          this._selectVariantByOption(e.target);

          // ensure updateURLParams exists and this.sectionId is defined before calling
          if (typeof updateURLParams === 'function') {
            try {
              const { queryURL, currentURL } = updateURLParams({ 'variant': this.variant.id }, this.sectionId, window.location.origin + this.getAttribute('product-url'));
              if (this.isProductPage && typeof historyPush === 'function') historyPush(currentURL);
            } catch (err) {
              // non-fatal
              console.warn('product-variant-selector: updateURLParams failed', err);
            }
          }

          this._checkUnavailable();

          const cached = this.cache[this.variant.id];

          if (cached) {
            this.forwardEvent('variantChange', {
              html: parseHTML(cached),
              variant: this.variant
            });
          } else {
            const queryURL = window.location.origin + this.getAttribute('product-url') + '?variant=' + this.variant.id;
            this._fetchPageWithVariant(queryURL, (html) => {
              this.cache[this.variant.id] = html;
              this.forwardEvent('variantChange', {
                html: parseHTML(html),
                variant: this.variant
              });
            });
          }

        }
      };

      _selectVariantByOption(target) {
        if (!this.optionsData) return;
        let valueIndex = this.optionsData.findIndex(option => option.name === target.name);
        if (target.hasAttribute && target.hasAttribute('data-unavailable')) {
          this.variant = this.variantsData.find(variant => variant.options[valueIndex] === target.value);
          this._toogleInputs(target);
        } else {
          let optionsToFind = this.variant ? [...this.variant.options] : [];
          optionsToFind[valueIndex] = target.value;
          this.variant = this._findVariantByOptions(optionsToFind);
        }
      };

      _toogleInputs(target) {
        if (!this.variant || !this.optionsData) return;
        this.variant.options.map((option, i) => {
          if (option !== target.value) {
            const input = this.querySelector(`input[value="${strEsc(option)}"][name="${strEsc(this.optionsData[i].name)}"]`);
            if (input) {
              input.checked = true;
              input.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: { synthetic: true } }));
            }
          }
        });
      };

      _findVariantByOptions(options) {
        return this.variantsData.find(variant => isEqual(variant.options, options));
      };

      _updateSwatchLable(swatchInput) {
        const swatch = swatchInput.closest('product-variant-swatch');
        if (swatch) {
          const el = swatch.querySelector('[data-swatch-value]') || swatch.querySelector('[data-swatch-value]');
          if (el) el.textContent = swatchInput.value;
        }
      };

      _fetchPageWithVariant(url, onResponse) {
        this.forwardEvent('variantLoading');
        return fetch(url)
          .then(response => response.text())
          .then(responseText => {
            onResponse(responseText);
          });
      };
    });

    customElements.define('product-option-picker', class extends baseComponent.default {
      elements = {
        value: '[data-option-value]'
      }
      render() {
        this.addEventListener('change', e => {
          if (this.$value) {
            this.$value.innerText = e.target.value;
          }
        })
      }
    });

  } catch (err) {
    console.error('product-variant-selector: initialization error', err);
  }
});
